/**
 * Simple category list used by the product form and the bulk edit page.
 * Values are stored as-is on `products.category`.
 */
export const productCategories = [
  'Shoes',
  'Hoodies/Tops',
  'T-Shirts',
  'Jackets',
  'Pants/Bottoms',
  'Hats',
  'Accessories',
  'Decor',
  'Other',
];
